import React from 'react'
import { useTranslation } from 'react-i18next'
import cookiesData from '../../src/data/content/cookiesData.json'

const CookiesPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <div className='bg-redpink text-white uppercase text-center lg:text-2xl py-2 mb-0'>
        {t('cookies.title')}
      </div>

      <div className='bg-grisclair mb-8 overflow-x-auto'>
        <div className='max-w-7xl mx-auto px-2 lg:px-0'>
          <nav className='flex space-x-6 py-4 text-sm md:text-sm'>
            {cookiesData.sections.map(section => (
              <a
                key={section.id}
                href={`#${section.id}`}
                className='text-anthracite whitespace-nowrap hover:text-redpink transition-colors duration-200'
              >
                {t(section.titleKey).split('. ')[1]}
              </a>
            ))}
          </nav>
        </div>
      </div>

      <article className='mx-auto max-w-7xl px-2 lg:px-0'>
        <div className='mb-8'>
          <p className='text-sm text-gray-500 mb-4'>
            {t('cookies.lastUpdate')} : {cookiesData.lastUpdate}
          </p>
          <p className='text-anthracite'>{t(cookiesData.introductionKey)}</p>
        </div>

        <div className='space-y-8'>
          {cookiesData.sections.map(section => (
            <section key={section.id} id={section.id} className='scroll-mt-20'>
              <h2 className='text-lg md:text-xl lg:text-2xl font-semibold text-redpink mb-4 md:mb-6'>
                {t(section.titleKey)}
              </h2>
              <div className='bg-grisclair p-4 md:p-6 rounded-lg'>
                {section.contentKeys.map((contentKey, index) => (
                  <React.Fragment key={contentKey}>
                    {index === 0 ? (
                      <p className='font-medium text-anthracite mb-3'>
                        {t(contentKey)}
                      </p>
                    ) : (
                      <p className='text-gray-600 ml-4 mb-2'>{t(contentKey)}</p>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </section>
          ))}
        </div>

        <footer className='mt-12 pt-8 border-t border-gray-200 mb-8'>
          <div className='text-gray-600 mb-4'>
            {t(cookiesData.footer.contact.textKey)}{' '}
            <a
              href={cookiesData.footer.contact.link.url}
              className='text-redpink hover:text-redpinkDark transition-colors duration-200'
            >
              {t(cookiesData.footer.contact.link.textKey)}
            </a>
          </div>
          <p className='text-sm text-gray-500 italic'>
            {t(cookiesData.footer.disclaimerKey)}
          </p>
        </footer>
      </article>
    </>
  )
}

export default CookiesPage
